<template>
  <div class="block__profile-collab" >

    <!-- ENTETE -->
    <div class="mobile">
      <div class="link">
          <button class="bt btn-back"  v-b-toggle.sidebar-3>
            <font-awesome-icon :icon="['far', 'angle-left']"/>
        </button>
        <h3>{{general.profileTitleCollaborators}}</h3>
      </div>
      <div class="sep"></div>
    </div>
    <!-- ENTETE -->



    <!-- CONTENT -->
    <div class="scrollable col">
      <h1>{{general.profileTitleCollaboratorsSave}}</h1>
      <p class="subtitle">{{general.profileTitleCollaboratorsSubTitle}}</p>

      <b-list-group>
       <PuSkeleton :loading="isLoading" :count="1" width='100%' height='2rem'>    
        <b-list-group-item :data-target="index"  v-for="(item,index) in infos" :key="`${index}-collab`">
          {{item.lastName | capitalize}} {{item.name | capitalize}}
          <div class="wrapper-button">
            <button class="bt-iconModify" @click="itemModify($event)">
                <font-awesome-icon :icon="['far', 'pencil-alt']"/>
            </button>
            <button class="bt-iconDelete" @click="itemDelete($event)">
              <font-awesome-icon :icon="['far', 'trash-alt']"/>
            </button>
          </div>
        </b-list-group-item>
       </PuSkeleton>
      </b-list-group>

      <button class="btn btn-add"  @click="addNewOne()">
        <font-awesome-icon :icon="['far', 'plus']"/>
        {{general.formBtAddCollab}}
      </button> 

    </div>
    <!-- CONTENT -->



    <!-- SIDEBAR -->
    <b-sidebar id="sidebar-collaborateur" right shadow :width="isMobile ?'100vw':'360px'">
      <FormCollab></FormCollab>
    </b-sidebar>
    <!-- SIDEBAR -->
  </div>

</template>




<script>
import { mapGetters } from 'vuex'
import FormCollab from '../../../module/modal/FormCollab'
import ApiService from '../../../../services/ApiService'
import ApiAuthenticationService from '../../../../services/ApiAuthenticationService'

export default {
  name:"profileCollab",
    components:{
      FormCollab
    }, 
    computed: {
      ...mapGetters([
        'getGeneral',
        'getNewCollab',
          'getIsMobile'
      ])
    },
    data () {
      return {
        general:"",
        isLoading:true,
        isMobile:false, 
        infos:[{},{}], 
        identity:{},  
      }
    },
    // GET ALL THE INFORMATIONS / TRANSLATION
    created (){
      this.general = this.getGeneral;
      this.isMobile = this.getIsMobile;
      this.getData();       
    },    

    methods : {
      // GET USER DATA
      async getData(){
        this.isLoading  = true;
        this.infos = await ApiService.getCollaboratorApi().get(ApiAuthenticationService.getCurrentUser().id);
        this.infos = this.infos.data;
        this.isLoading  = false;
      },

      // GO BACK
      goBack() {
        this.$router.push({name: "profileHome"});  
      }, 

      // ADD NEW ONE
      addNewOne(){
        this.identity = {};
        this.$store.dispatch('setInfosCollab',this.identity);
        this.$root.$emit('bv::toggle::collapse', 'sidebar-collaborateur')
      },  
      
      // UPDATE ONE
      itemModify(e){
        this.identity = this.infos[this.getTarget(e)];
        this.$store.dispatch('setInfosCollab',this.identity);
        this.$root.$emit('bv::toggle::collapse', 'sidebar-collaborateur')
      },  
      
      // DELETE ONE      
      async itemDelete(e){
        const target = this.infos[this.getTarget(e)].id;
        this.infos.splice(this.getTarget(e),1);
        let patched = await ApiService.getCollaboratorApi().remove(target);
        patched.status == '200' ?  this.messageSuccess() : this.messageError();
      },   
      
      // GET THE TARGET
      getTarget(e){
        const $target = e.target.closest('.list-group-item');
        return $target.getAttribute('data-target');
      },


      // IF SUCCESS
      messageSuccess(){
        this.makeToast('success')    
      },  
      
      // IF ERROR
      messageError(){
        this.makeToast('error')
      },  

      //AFFICHAGE DU TOAST
      makeToast(variant = null) {
        if(variant == 'success'){
          this.$bvToast.toast(this.general.collabDeleteSuccess, {
            title: this.general.collabToastDeleteTitle,
            variant: variant,
            solid: true,
            toaster:'b-toaster-top-center'
          })  
        } else if(variant == 'error'){
          this.$bvToast.toast(this.general.collabdeleteError, {
            title: this.general.collabToastDeleteTitle,
            variant: variant,
            solid: true,
            toaster:'b-toaster-top-center'
          }) 
        } 
        // else if(variant == 'info'){
        //   this.$bvToast.toast('Le challenge a été mis à jour.', {
        //     title: `Enregistrement challenge`,
        //     variant: 'success',
        //     solid: true,
        //     toaster:'b-toaster-top-center'
        //   }) 
      },

    },

   watch: {
    //  WATCH IF NEW COLLAB
    getNewCollab() {  
      this.getData();
    },
     getIsMobile(){
      this.isMobile = this.getIsMobile;
     }
  },

  filters: {
    // UPPERCASE FIRST LETTER
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }      
};
</script>
